export * from "@workspace/gamja-platform/components/ui/dialog";
